import { createFileRoute } from "@tanstack/react-router";
import { DocusignTemplatePage } from "@/pages/docusign-template/docusign-template-page.tsx";

export const Route = createFileRoute("/_auth/_isAdmin/einstellungen/docusign/")(
  {
    component: RouteComponent,
  },
);

function RouteComponent() {
  return <DocusignTemplatePage />;
}
